import React from 'react';

/**
 * Skeleton
 * ------------------------------------------------------------------
 * Lightweight shimmer placeholder used across project detail / overview
 * loading states. Prefer width/height props or CSS class sizing.
 */
const Skeleton = ({
  width,
  height,
  circle = false,
  className = '',
  style = {},
  ...rest
}) => {
  const classes = ['amok-skeleton', circle ? 'amok-skeleton--circle' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      className={classes}
      style={{ width, height, ...style }}
      aria-hidden="true"
      {...rest}
    />
  );
};

export default Skeleton;
